export enum RepossessionType {
  No = 'No',
  Friendly = 'Friendly',
  Unfriendly = 'Unfriendly',
}
